import request from '@/utils/request'

export function getCoachList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetCoachList.json',
    method: 'post',
    data
  })
}

export function getCoach(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetCoach.json',
    method: 'post',
    data
  })
}

export function updateCoach(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateCoach.json',
    method: 'post',
    data
  })
}
